module.exports = __webpack_public_path__ + "img/email.91c1c2c9.svg";